/** Closed presentation copy for application tools. Never print raw tool names or arguments. */
export const TOOL_ACTIVITY_COPY = {
  checking_proposal_status: {
    active: () => "Checking proposal status…",
    done: () => "Checked proposal status",
    failed: () => "Couldn’t confirm the proposal was applied",
  },
  loading_guidance: {
    active: () => "Loading relevant guidance…",
    done: () => "Loaded relevant guidance",
    failed: () => "Couldn’t load relevant guidance",
  },
  reading_canvas_context: {
    active: () => "Reading canvas context…",
    done: () => "Read canvas context",
    failed: () => "Couldn’t read canvas context",
  },
  checking_canvas_widgets: {
    active: () => "Checking what’s on the canvas…",
    done: () => "Checked what’s on the canvas",
    failed: () => "Couldn’t check what’s on the canvas",
  },
  inspecting_widgets: {
    active: () => "Inspecting canvas widgets…",
    done: () => "Inspected canvas widgets",
    failed: () => "Couldn’t inspect canvas widgets",
  },
  checking_widget_actions: {
    active: () => "Checking available widget actions…",
    done: () => "Checked available widget actions",
    failed: () => "Couldn’t check available widget actions",
  },
  reading_widget: {
    active: (subject: string | null) =>
      `Reading ${subject ?? "canvas widget"}…`,
    done: (subject: string | null) => `Read ${subject ?? "canvas widget"}`,
    failed: (subject: string | null) =>
      `Couldn’t read ${subject ?? "canvas widget"}`,
  },
  requesting_canvas_review: {
    active: () => "Requesting a canvas review…",
    done: () => "Canvas review requested",
    failed: () => "Couldn’t request a canvas review",
  },
  preparing_phase_advance: {
    active: () => "Preparing the next-phase proposal…",
    done: () => "The next-phase proposal is ready for review",
    failed: () => "Couldn’t prepare the next-phase proposal",
  },
  checking_workshop_documents: {
    active: () => "Checking workshop documents…",
    done: () => "Checked workshop documents",
    failed: () => "Couldn’t check workshop documents",
  },
  checking_comment_threads: {
    active: () => "Checking comment threads…",
    done: () => "Checked comment threads",
    failed: () => "Couldn’t check comment threads",
  },
  checking_participants: {
    active: () => "Checking workshop participants…",
    done: () => "Checked workshop participants",
    failed: () => "Couldn’t check workshop participants",
  },
  checking_map_layout: {
    active: () => "Checking the map layout…",
    done: () => "Checked the map layout",
    failed: () => "Couldn’t check the map layout",
  },
  reading_workshop_document: {
    active: () => "Reading a workshop document…",
    done: () => "Read a workshop document",
    failed: () => "Couldn’t read a workshop document",
  },
  reading_comments: {
    active: () => "Reading comments…",
    done: () => "Read comments",
    failed: () => "Couldn’t read comments",
  },
  reading_map: {
    active: () => "Reading the map…",
    done: () => "Read the map",
    failed: () => "Couldn’t read the map",
  },
  reading_improvements: {
    active: () => "Reading improvement opportunities…",
    done: () => "Read improvement opportunities",
    failed: () => "Couldn’t read improvement opportunities",
  },
  reading_vsm_workspace: {
    active: () => "Reading the VSM workspace…",
    done: () => "Read the VSM workspace",
    failed: () => "Couldn’t read the VSM workspace",
  },
  inspecting_map_item: {
    active: () => "Inspecting a map item…",
    done: () => "Inspected a map item",
    failed: () => "Couldn’t inspect a map item",
  },
  inspecting_map_items: {
    active: () => "Inspecting map items…",
    done: () => "Inspected map items",
    failed: () => "Couldn’t inspect map items",
  },
  inspecting_map_neighbourhood: {
    active: () => "Inspecting nearby map items and connections…",
    done: () => "Inspected nearby map items and connections",
    failed: () => "Couldn’t inspect nearby map items and connections",
  },
  reviewing_preparation: {
    active: () => "Reviewing workshop preparation…",
    done: () => "Reviewed workshop preparation",
    failed: () => "Couldn’t review workshop preparation",
  },
  preparing_framing: {
    active: () => "Preparing workshop framing changes…",
    done: () => "Workshop framing changes ready for review",
    failed: () => "Couldn’t prepare workshop framing changes",
  },
  preparing_sipoc: {
    active: () => "Preparing SIPOC changes…",
    done: () => "SIPOC changes ready for review",
    failed: () => "Couldn’t prepare SIPOC changes",
  },
  preparing_comment: {
    active: () => "Preparing a comment…",
    done: () => "A comment is ready for review",
    failed: () => "Couldn’t prepare a comment",
  },
  preparing_map: {
    active: () => "Preparing map changes…",
    done: () => "Map changes ready for review",
    failed: () => "Couldn’t prepare map changes",
  },
  preparing_improvements: {
    active: () => "Preparing improvement opportunity changes…",
    done: () => "Improvement opportunity changes ready for review",
    failed: () => "Couldn’t prepare improvement opportunity changes",
  },
  preparing_impact_effort: {
    active: () => "Preparing impact and effort changes…",
    done: () => "Impact and effort changes ready for review",
    failed: () => "Couldn’t prepare impact and effort changes",
  },
  preparing_implementation: {
    active: () => "Preparing implementation plan changes…",
    done: () => "Implementation plan changes ready for review",
    failed: () => "Couldn’t prepare implementation plan changes",
  },
  preparing_control_plan: {
    active: () => "Preparing control plan changes…",
    done: () => "Control plan changes ready for review",
    failed: () => "Couldn’t prepare control plan changes",
  },
  preparing_workshop_notes: {
    active: () => "Preparing workshop notes changes…",
    done: () => "Workshop notes changes ready for review",
    failed: () => "Couldn’t prepare workshop notes changes",
  },
  preparing_file_sharing: {
    active: () => "Preparing to share a file with the workshop…",
    done: () => "File-sharing proposal ready for review",
    failed: () => "Couldn’t prepare file sharing",
  },
  reading_linked_solve: {
    active: () => "Reading the linked SOLVE…",
    done: () => "Read the linked SOLVE",
    failed: () => "Couldn’t read the linked SOLVE",
  },
  reading_workshop_ideas: {
    active: () => "Reading workshop ideas…",
    done: () => "Read workshop ideas",
    failed: () => "Couldn’t read workshop ideas",
  },
  preparing_private_ideas: {
    active: () => "Preparing ideas for your private canvas…",
    done: () => "Ideas ready to add to your private canvas",
    failed: () => "Couldn’t prepare private canvas ideas",
  },
  preparing_idea_submission: {
    active: () => "Preparing your ideas for submission…",
    done: () => "Ideas ready for submission",
    failed: () => "Couldn’t prepare idea submission",
  },
  preparing_duplicate_review: {
    active: () => "Preparing a duplicate-idea review…",
    done: () => "A duplicate-idea review is ready for review",
    failed: () => "Couldn’t prepare a duplicate-idea review",
  },
  preparing_idea_groups: {
    active: () => "Preparing suggested idea groups…",
    done: () => "Suggested idea groups ready for review",
    failed: () => "Couldn’t prepare suggested idea groups",
  },
  preparing_idea_scores: {
    active: () => "Preparing impact and effort scores…",
    done: () => "Impact and effort scores ready for review",
    failed: () => "Couldn’t prepare impact and effort scores",
  },
  preparing_x_matrix: {
    active: () => "Preparing X-Matrix changes…",
    done: () => "X-Matrix changes ready for review",
    failed: () => "Couldn’t prepare X-Matrix changes",
  },
  reading_x_matrix: {
    active: () => "Reading the X-Matrix…",
    done: () => "Read the X-Matrix",
    failed: () => "Couldn’t read the X-Matrix",
  },
  getting_work_overview: {
    active: () => "Getting an overview of your work…",
    done: () => "Got an overview of your work",
    failed: () => "Couldn’t get an overview of your work",
  },
  checking_work_items: {
    active: () => "Checking your work items…",
    done: () => "Checked your work items",
    failed: () => "Couldn’t check your work items",
  },
  reading_work_item: {
    active: () => "Reading work item details…",
    done: () => "Read work item details",
    failed: () => "Couldn’t read work item details",
  },
  checking_work_changes: {
    active: () => "Checking recent changes to your work…",
    done: () => "Checked recent changes to your work",
    failed: () => "Couldn’t check recent changes to your work",
  },
  searching_workspace: {
    active: () => "Searching the workspace…",
    done: () => "Searched the workspace",
    failed: () => "Couldn’t search the workspace",
  },
  preparing_navigation: {
    active: () => "Preparing a navigation link…",
    done: () => "Navigation link ready",
    failed: () => "Couldn’t prepare a navigation link",
  },
  searching_kpis: {
    active: () => "Looking up KPIs…",
    done: () => "Looked up KPIs",
    failed: () => "Couldn’t look up KPIs",
  },
  checking_notifications: {
    active: () => "Checking your notifications…",
    done: () => "Checked your notifications",
    failed: () => "Couldn’t check your notifications",
  },
  reading_notification: {
    active: () => "Reading notification details…",
    done: () => "Read notification details",
    failed: () => "Couldn’t read notification details",
  },
  checking_unread_notifications: {
    active: () => "Checking unread notifications…",
    done: () => "Checked unread notifications",
    failed: () => "Couldn’t check unread notifications",
  },
  reading_settings: {
    active: () => "Reading your settings…",
    done: () => "Read your settings",
    failed: () => "Couldn’t read your settings",
  },
  reading_mood: {
    active: () => "Reading your mood history…",
    done: () => "Read your mood history",
    failed: () => "Couldn’t read your mood history",
  },
  reading_questionnaire: {
    active: () => "Reading the questionnaire…",
    done: () => "Read the questionnaire",
    failed: () => "Couldn’t read the questionnaire",
  },
  reading_campaign: {
    active: () => "Reading campaign details…",
    done: () => "Read campaign details",
    failed: () => "Couldn’t read campaign details",
  },
  reading_assignment: {
    active: () => "Reading assessment assignment details…",
    done: () => "Read assessment assignment details",
    failed: () => "Couldn’t read assessment assignment details",
  },
  reading_assessment_report: {
    active: () => "Reading the assessment report…",
    done: () => "Read the assessment report",
    failed: () => "Couldn’t read the assessment report",
  },
  reading_assessment_responses: {
    active: () => "Reading assessment responses…",
    done: () => "Read assessment responses",
    failed: () => "Couldn’t read assessment responses",
  },
  checking_campaign_progress: {
    active: () => "Checking campaign progress…",
    done: () => "Checked campaign progress",
    failed: () => "Couldn’t check campaign progress",
  },
  checking_assessment_reports: {
    active: () => "Checking available assessment reports…",
    done: () => "Checked available assessment reports",
    failed: () => "Couldn’t check available assessment reports",
  },
  searching_admin: {
    active: () => "Searching administration records…",
    done: () => "Searched administration records",
    failed: () => "Couldn’t search administration records",
  },
  reading_admin: {
    active: () => "Reading administration details…",
    done: () => "Read administration details",
    failed: () => "Couldn’t read administration details",
  },
  comparing_admin: {
    active: () => "Comparing administration records…",
    done: () => "Compared administration records",
    failed: () => "Couldn’t compare administration records",
  },
  reading_audit: {
    active: () => "Reading audit history…",
    done: () => "Read audit history",
    failed: () => "Couldn’t read audit history",
  },
  preparing_settings: {
    active: () => "Preparing a settings change…",
    done: () => "A settings change is ready for review",
    failed: () => "Couldn’t prepare a settings change",
  },
  preparing_notification_preferences: {
    active: () => "Preparing notification preference changes…",
    done: () => "Notification preference changes ready for review",
    failed: () => "Couldn’t prepare notification preference changes",
  },
  preparing_acknowledgement: {
    active: () => "Preparing a notification acknowledgement…",
    done: () => "A notification acknowledgement is ready for review",
    failed: () => "Couldn’t prepare a notification acknowledgement",
  },
  preparing_resource_sharing: {
    active: () => "Preparing a resource-sharing change…",
    done: () => "A resource-sharing change is ready for review",
    failed: () => "Couldn’t prepare a resource-sharing change",
  },
  preparing_improvement_owner: {
    active: () => "Preparing an improvement owner change…",
    done: () => "An improvement owner change is ready for review",
    failed: () => "Couldn’t prepare an improvement owner change",
  },
  preparing_improvement_date: {
    active: () => "Preparing an improvement due-date change…",
    done: () => "An improvement due-date change is ready for review",
    failed: () => "Couldn’t prepare an improvement due-date change",
  },
  preparing_improvement_status: {
    active: () => "Preparing an improvement status change…",
    done: () => "An improvement status change is ready for review",
    failed: () => "Couldn’t prepare an improvement status change",
  },
  preparing_objective_owner: {
    active: () => "Preparing an objective owner change…",
    done: () => "An objective owner change is ready for review",
    failed: () => "Couldn’t prepare an objective owner change",
  },
  preparing_target_date: {
    active: () => "Preparing a target date change…",
    done: () => "A target date change is ready for review",
    failed: () => "Couldn’t prepare a target date change",
  },
  preparing_hoshin_status: {
    active: () => "Preparing a Hoshin status change…",
    done: () => "A Hoshin status change is ready for review",
    failed: () => "Couldn’t prepare a Hoshin status change",
  },
  preparing_assessment_comment: {
    active: () => "Preparing an assessment comment change…",
    done: () => "An assessment comment change is ready for review",
    failed: () => "Couldn’t prepare an assessment comment change",
  },
  preparing_assessment_responses: {
    active: () => "Preparing assessment response changes…",
    done: () => "Assessment response changes ready for review",
    failed: () => "Couldn’t prepare assessment response changes",
  },
  preparing_assessment_submission: {
    active: () => "Preparing assessment submission…",
    done: () => "Assessment submission ready for review",
    failed: () => "Couldn’t prepare assessment submission",
  },
  preparing_notification_read: {
    active: () => "Preparing to mark a notification as read…",
    done: () => "Notification read change ready for review",
    failed: () => "Couldn’t prepare the change",
  },
  preparing_notification_unread: {
    active: () => "Preparing to mark a notification as unread…",
    done: () => "Notification unread change ready for review",
    failed: () => "Couldn’t prepare the change",
  },
  preparing_notifications_read: {
    active: () => "Preparing to mark all notifications as read…",
    done: () => "Notification read changes ready for review",
    failed: () => "Couldn’t prepare the change",
  },
  preparing_resource_unsharing: {
    active: () => "Preparing to remove resource sharing…",
    done: () => "Resource-sharing removal ready for review",
    failed: () => "Couldn’t prepare the change",
  },
  preparing_widget_create: {
    active: (subject: string | null) =>
      `Preparing a new ${subject ?? "canvas widget"}…`,
    done: (subject: string | null) =>
      `New ${subject ?? "canvas widget"} ready for review`,
    failed: (subject: string | null) =>
      `Couldn’t prepare a new ${subject ?? "canvas widget"}`,
  },
  preparing_widget_change: {
    active: (subject: string | null) =>
      `Preparing changes to ${subject ?? "canvas widget"}…`,
    done: (subject: string | null) =>
      `Changes to ${subject ?? "canvas widget"} ready for review`,
    failed: (subject: string | null) =>
      `Couldn’t prepare changes to ${subject ?? "canvas widget"}`,
  },
  preparing_widget_add: {
    active: (subject: string | null) =>
      `Preparing additions to ${subject ?? "canvas widget"}…`,
    done: (subject: string | null) =>
      `Additions to ${subject ?? "canvas widget"} ready for review`,
    failed: (subject: string | null) =>
      `Couldn’t prepare additions to ${subject ?? "canvas widget"}`,
  },
  preparing_widget_remove: {
    active: (subject: string | null) =>
      `Preparing item removals from ${subject ?? "canvas widget"}…`,
    done: (subject: string | null) =>
      `Item removals from ${subject ?? "canvas widget"} ready for review`,
    failed: (subject: string | null) =>
      `Couldn’t prepare item removals from ${subject ?? "canvas widget"}`,
  },
  preparing_widget_unplace: {
    active: (subject: string | null) =>
      `Preparing to remove ${subject ?? "canvas widget"} from the canvas…`,
    done: (subject: string | null) =>
      `Removal of ${subject ?? "canvas widget"} ready for review`,
    failed: (subject: string | null) =>
      `Couldn’t prepare removal of ${subject ?? "canvas widget"}`,
  },
  applying_tool_change: {
    active: () => "Applying the approved change…",
    done: () => "Approved change applied",
    failed: () => "Couldn’t apply the approved change",
  },
  applying_widget_change: {
    active: (subject: string | null) =>
      `Applying approved changes to ${subject ?? "canvas widget"}…`,
    done: (subject: string | null) => `Updated ${subject ?? "canvas widget"}`,
    failed: (subject: string | null) =>
      `Couldn’t apply approved changes to ${subject ?? "canvas widget"}`,
  },
  running_tool: {
    active: () => "Working on your request…",
    done: () => "Finished a step",
    failed: () => "A step didn’t finish",
  },
};

/** Only these code-owned labels may be rendered from safe_label. */
export const ACTIVITY_WIDGET_LABELS: ReadonlySet<string> = new Set([
  "Problem Statement",
  "Tags",
  "Run Chart",
  "KPI Tile",
  "Problem Tree",
  "Problem Timeline",
  "Containment Plan",
  "Exposure Risk Review",
  "Pareto L1",
  "Pareto L2",
  "Funnel",
  "Causal Chain",
  "Fishbone",
  "Process Trace",
  "Impact–Effort Matrix",
  "Countermeasure Table",
  "Stakeholder Map",
  "Control Plan",
  "Escalation Matrix",
  "Table",
  "Notes",
  "Brainstorm Board",
]);

/** Narrow before passing wire metadata into presentation props. */
export function activityWidgetLabel(
  kind: string,
  label: unknown,
): string | null {
  const widgetActivity =
    kind === "reading_widget" ||
    kind.startsWith("preparing_widget_") ||
    kind === "applying_widget_change";
  return widgetActivity &&
    typeof label === "string" &&
    ACTIVITY_WIDGET_LABELS.has(label)
    ? label
    : null;
}
